import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { MainProvider } from './Context/MainContext';

// Responsável por recarregar a página no caso de deploy
// const addServiceWorker = () => {
//     window.addEventListener('load', () => {
//         navigator.serviceWorker.register('/service-worker.js').then(registration => {
//             console.log('SW registrado.');
//             let initialTrigger = true;
//             registration.onupdatefound = () => {
//                 if(!initialTrigger) console.log('Update encontrado');
//                 initialTrigger = false;
//                 // const installingWorker = registration.installing;
//                 // installingWorker.onstatechange = () => {
//                 //     if (installingWorker.state === 'installed' && navigator.serviceWorker.controller) {
//                 //         // Nova atualização disponível
//                 //         const userConfirmed = window.confirm('Uma nova versão está disponível. Deseja atualizar o site agora?');
//                 //         if (userConfirmed) {
//                 //             // Para evitar o loop, recarregue sem trigger no evento controllerchange
//                 //             installingWorker.postMessage({ type: 'SKIP_WAITING' });
//                 //         }
//                 //     }
//                 // };
//             };
//         }).catch(error => {
//             console.error('Falha ao registrar o Service Worker:', error);
//         });

//         // Impedir loops verificando se já houve uma mudança no controller
//         // let refreshing = false;
//         // navigator.serviceWorker.addEventListener('controllerchange', () => {
//         //     if (!refreshing) {
//         //         refreshing = true;
//         //         window.location.reload();
//         //     }
//         // });
//     });
// };


if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations()
        .then(registrations => {
            registrations.forEach(registration => {
                registration.unregister();
            });
        })
        // .then(addServiceWorker)
        .catch(error => {
            console.error('Erro ao desregistrar service workers:', error);
        });
}



const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <MainProvider>
        <App />
    </MainProvider>
);